import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import { MdClear as CloseIcon } from 'react-icons/md';
import IconButton from '@material-ui/core/IconButton';
import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core';

import { AccentColor } from 'helpers/AccentColorHelper';
import { deepDiver } from 'helpers/utilities';
import { colors } from 'helpers/ColorHelper';

import Paper from '@material-ui/core/Paper';
import ManualApplicantForm from './ManualApplicantForm';

import { createOrUpdateApplicant, getApplication } from 'actions/landlordApplicationsActions';
import { openEditLease } from 'actions/LeaseDetailsActions';
import { connect } from 'react-redux';

import { submit } from 'redux-form';

const muiThemeOverride = {
  overrides: {
    MuiTypography: {
      display1: {
        fontFamily: 'Circular',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'initial',
      },
      label: {
        fontFamily: 'Circular',
      },
    },
  },
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    height: 430,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'white',
    color: 'black',
    boxShadow: 'none !important',
  },
  content: {
    flexGrow: 1,
    backgroundColor: 'white',
    minWidth: 0,
    overflow: 'auto',
  },
  paper: {
    boxShadow: 'none !important',
  },
  toolbar: theme.mixins.toolbar,
});

let ManualApplicantDrawer = class extends React.Component {
  submitApplicant = async (applicationId, applicantId, data) => {
    const response = await this.props.createOrUpdateApplicant(applicationId, applicantId, data);
    if (response) {
      await this.props.getApplication(applicationId);
      this.props.getApplicationsAndClearOffset();
      this.props.onClose();
    }
  };

  onSave = () => {
    this.props.remoteSubmit('manual_applicant_form');
  };

  render() {
    const fullName = this.getApplicantFullName(this.props.applicant);

    return (
      <Drawer anchor="bottom" open={this.props.open} onClose={this.props.onClose}>
        <div tabIndex={0} style={{ minHeight: '100vh' }}>
          <div className={this.props.classes.root}>
            <MuiThemeProvider theme={createMuiTheme(muiThemeOverride)}>
              <AppBar position="absolute" className={this.props.classes.appBar} id="appbar">
                <Toolbar style={{ color: 'white', fontSize: '22px' }} variant="dense">
                  <IconButton
                    color="inherit"
                    style={{ marginLeft: '-10px', marginRight: '5px', color: colors.DARK_GRAY }}
                    onClick={this.props.onClose}
                    aria-label="Close"
                  >
                    <CloseIcon size={24} />
                  </IconButton>

                  <Typography
                    variant="display1"
                    color="inherit"
                    style={{ flexGrow: 1, fontFamily: 'Circular-Black', color: colors.DARK_GRAY }}
                  >
                    Rental Application for {fullName}
                  </Typography>

                  <Button
                    color="inherit"
                    style={{ fontSize: '15px', color: AccentColor(), fontFamily: 'Circular-Bold' }}
                    onClick={this.onSave}
                  >
                    Submit
                  </Button>
                </Toolbar>
              </AppBar>
            </MuiThemeProvider>
            <main className={this.props.classes.content}>
              <div className={this.props.classes.toolbar} />
              <Paper style={{ minHeight: '100vh' }} elevation={0}>
                <ManualApplicantForm
                  initialValues={{ apply_in_person: true, ...this.props.applicant }}
                  onSubmit={(data) =>
                    this.submitApplicant(this.props.application.id, this.props.applicant.id, data)
                  }
                />
              </Paper>
            </main>
          </div>
        </div>
      </Drawer>
    );
  }

  getApplicantFullName = (applicant) => {
    return `${deepDiver(applicant, 'first_name') || ''} ${deepDiver(applicant, 'last_name') || ''}`;
  };
};

ManualApplicantDrawer = connect(
  (store) => ({
    application: store.landlordApplications.application,
  }),
  { createOrUpdateApplicant, remoteSubmit: submit, getApplication, openEditLease }
)(ManualApplicantDrawer);

export default withStyles(styles)(ManualApplicantDrawer);
